<div class="flex flex-col gap-4" [formGroup]="form()">
  @if (requestTypeOptions().length) {
    <h5 class="x-font-body-3 mt-2 text-(--tui-text-primary)">
      {{ 'request_create.section_request_type' | translate }}
    </h5>

    <div class="grid gap-4 md:grid-cols-2">
      <tui-textfield
        tuiChevron
        [stringify]="stringifyRequestType"
        tuiTextfieldSize="m"
      >
        <label tuiLabel>
          {{ 'request_create.request_type' | translate }}
        </label>

        <input tuiSelect [formControl]="requestTypeControl()" />
        <ng-template tuiDropdown>
          <tui-data-list>
            @for (option of requestTypeOptions(); track option.value) {
              <button tuiOption type="button" [value]="option.value">
                {{ option.label }}
              </button>
            }
          </tui-data-list>
        </ng-template>
      </tui-textfield>
    </div>
  }

  @if (visibleExtraFields().length) {
    <div class="grid gap-4 md:grid-cols-2" [formGroup]="extraForm()">
      @for (field of visibleExtraFields(); track field.name) {
        @if (extraControl(field.name); as control) {
          @switch (field.fieldType) {
            @case ('date') {
              <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
                <label tuiLabel>
                  {{ field.title }}
                </label>

                <input tuiInputDate [formControl]="control" />
                <tui-calendar *tuiDropdown />
              </tui-textfield>
            }
            @default {
              <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
                <label tuiLabel>{{ field.title }}</label>
                <input tuiInput maxlength="256" [formControl]="control" />
              </tui-textfield>
            }
          }
        }
      }
    </div>
  }

  <h5 class="x-font-body-3 mt-2 text-(--tui-text-primary)">
    {{ 'request_create.section_managers' | translate }}
  </h5>

  <div class="grid gap-4 md:grid-cols-2">
    <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
      <label tuiLabel>{{ 'request_create.support_manager' | translate }}</label>
      <input
        tuiInput
        maxlength="256"
        formControlName="supportManagerFullname"
      />
    </tui-textfield>

    <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
      <label tuiLabel>{{
        'request_create.support_manager_phone' | translate
      }}</label>
      <input tuiInput maxlength="256" formControlName="supportManagerPhone" />
    </tui-textfield>

    <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
      <label tuiLabel>{{ 'request_create.client_manager' | translate }}</label>
      <input tuiInput maxlength="256" formControlName="clientManagerFullname" />
    </tui-textfield>

    <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
      <label tuiLabel>{{
        'request_create.client_manager_phone' | translate
      }}</label>
      <input tuiInput maxlength="256" formControlName="clientManagerPhone" />
    </tui-textfield>

    <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
      <label tuiLabel>{{
        'request_create.client_manager_email' | translate
      }}</label>
      <input tuiInput type="email" formControlName="clientManagerEmail" />
    </tui-textfield>
  </div>

  <h5 class="x-font-body-3 mt-2 text-(--tui-text-primary)">
    {{ 'request_create.section_additional' | translate }}
  </h5>

  <div class="grid gap-4 md:grid-cols-2">
    <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
      <label tuiLabel>{{
        'request_create.shipment_docs_address' | translate
      }}</label>
      <input tuiInput formControlName="shipmentDocsAddress" />
    </tui-textfield>

    <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
      <label tuiLabel>{{
        'request_create.shipment_keys_address' | translate
      }}</label>
      <input tuiInput formControlName="shipmentKeysAddress" />
    </tui-textfield>

    <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
      <label tuiLabel>{{ 'request_create.timezone' | translate }}</label>
      <input tuiInput placeholder="UTC+3" formControlName="timezone" />
    </tui-textfield>
  </div>

  <h5 class="x-font-body-3 mt-2 text-(--tui-text-primary)">
    {{ 'request_create.section_executor' | translate }}
  </h5>

  <div class="grid gap-4 md:grid-cols-2">
    <tui-textfield
      tuiChevron
      [stringify]="stringifyContractor"
      [tuiTextfieldCleaner]="true"
      tuiTextfieldSize="m"
    >
      <label tuiLabel>
        {{ 'request_create.contractor' | translate }}
      </label>

      <input tuiSelect formControlName="contractorCounterpartyId" />
      <ng-template tuiDropdown>
        <tui-data-list>
          @for (contractor of contractors(); track contractor.id) {
            <button tuiOption type="button" [value]="contractor.id">
              {{ contractor.name }}
            </button>
          }
        </tui-data-list>
      </ng-template>
    </tui-textfield>

    <tui-textfield
      tuiChevron
      [stringify]="stringifySubdivision"
      [tuiTextfieldCleaner]="true"
      tuiTextfieldSize="m"
    >
      <label tuiLabel>
        {{ 'request_create.contractor_subdivision' | translate }}
      </label>

      <input tuiSelect formControlName="contractorCounterpartySubdivisionId" />
      <ng-template tuiDropdown>
        <tui-data-list>
          @for (subdivision of subdivisions(); track subdivision.id) {
            <button tuiOption type="button" [value]="subdivision.id">
              {{ subdivision.name }}
            </button>
          }
        </tui-data-list>
      </ng-template>
    </tui-textfield>

    <tui-textfield [tuiTextfieldCleaner]="true" tuiTextfieldSize="m">
      <label tuiLabel>{{ 'request_create.install_price' | translate }}</label>
      <input tuiInput maxlength="10" formControlName="installPrice" />
    </tui-textfield>
  </div>

  <h5 class="x-font-body-3 mt-2 text-(--tui-text-primary)">
    {{ 'request_create.section_products' | translate }}
  </h5>

  <div class="flex flex-col gap-3">
    @if (selectedProducts().length) {
      <div
        class="overflow-hidden rounded-md border border-(--tui-background-neutral-1-hover)"
      >
        @for (product of selectedProducts(); track product.productId) {
          <div
            class="grid grid-cols-[1fr_80px_44px] items-center gap-3 border-b border-(--tui-background-neutral-1-hover) px-3 py-2 last:border-b-0"
          >
            <span>{{ product.name }}</span>
            <span>{{ product.amount }}</span>
            <button
              tuiButton
              type="button"
              size="xs"
              appearance="flat"
              (click)="removeProduct.emit(product.productId)"
            >
              X
            </button>
          </div>
        }
      </div>
    }

    <div class="grid items-end gap-3 md:grid-cols-[1fr_120px_auto]">
      <tui-textfield
        [stringify]="stringifyProduct"
        [tuiTextfieldCleaner]="true"
        tuiTextfieldSize="m"
      >
        <label tuiLabel>
          {{ 'request_create.product' | translate }}
        </label>

        <input
          tuiComboBox
          [formControl]="productIdControl"
          (input)="productSearch.set($any($event.target).value ?? '')"
        />
        <ng-template tuiDropdown>
          <tui-data-list>
            @for (product of filteredProducts(); track product.id) {
              <button tuiOption type="button" [value]="product.id">
                {{ product.name }}
              </button>
            }
          </tui-data-list>
        </ng-template>
      </tui-textfield>

      <tui-textfield [tuiNumberFormat]="{ precision: 0 }" tuiTextfieldSize="m">
        <label tuiLabel>
          {{ 'request_create.product_amount' | translate }}
        </label>

        <input tuiInputNumber [formControl]="amountControl" />
      </tui-textfield>

      <button tuiButton type="button" size="m" (click)="emitAddProduct()">
        {{ 'request_create.add_product' | translate }}
      </button>
    </div>
  </div>
</div>
